import { beforeRequestInterceptor } from './utils/beforeRequestInterceptor';
import { kyBeforeRequestValidateTokenInterceptor } from '@/@core/services/auth/validateTokenInterceptor';
import { http } from '@aleph-alpha/lib-http';

export const HTTP_CLIENT = http({
  baseURL: '/api',
  retry: {
    limit: 20,
    methods: ['get'],
    statusCodes: [404],
  },
  hooks: {
    beforeRequest: [kyBeforeRequestValidateTokenInterceptor],
  },
});

export const HTTP_CLIENT_IAM = http({
  baseURL: '/api/iam',
  hooks: {
    beforeRequest: [kyBeforeRequestValidateTokenInterceptor],
  },
});

export const HTTP_CLIENT_NLS = http({
  baseURL: '/nls',
  retry: {
    limit: 7,
    methods: ['get', 'post'],
    statusCodes: [404],
  },
  hooks: {
    beforeRequest: [beforeRequestInterceptor],
  },
});

export const HTTP_CLIENT_CONDUCTOR = http({
  baseURL: '/api/conductor',
  hooks: {
    beforeRequest: [beforeRequestInterceptor],
  },
});

export const EXTERNAL_REQUEST_HTTP_CLIENT = http({
  retry: {
    limit: 5,
    methods: ['get'],
    statusCodes: [404],
  },
  hooks: {
    beforeRequest: [kyBeforeRequestValidateTokenInterceptor],
  },
});
